<template>
  <div>
    <b-container class="p-relative">
      <div class="header-text-container">
        <div class="header-text">{{ header }}</div>
      </div>
    </b-container>

    <div class="cover-image">
      <div class="cover-overlay"></div>
    </div>

    <b-container :class="isMobile ? 'mb-5' : 'form-container'">
      <board-form />
    </b-container>
  </div>
</template>

<script>
import BoardForm from '@/components/forms/BoardForm'
export default {
  components: {
    BoardForm
  },

  data() {
    return {
      header: ''
    }
  },

  created() {
    this.header =
      this.$router.currentRoute.name === 'board.new-main-board-page'
        ? 'New Main Switchboard'
        : 'New Main Distribution Board'
  }
}
</script>

<style scoped>
.header-text-container {
  position: absolute;
  color: white;
  top: 95px;
  z-index: 2;
}
.header-text {
  font-size: 24px;
  font-weight: bold;
}
.cover-image {
  width: 100%;
  min-height: 160px;
  background: url('~@/assets/images/cover.jpeg');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0.9;
}
.cover-overlay {
  width: 100%;
  min-height: 160px;
  background-blend-mode: multiply;
  background: transparent url('~@/assets/images/overlay.svg') 0% 0% no-repeat
    padding-box;
  background-size: cover;
  background-repeat: no-repeat;
}
.form-container {
  position: relative;
  /* margin: 0 10%; */
  margin-bottom: 100px;
}
</style>
